import React from 'react';
import NumberFormat from 'react-number-format';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    position: 'relative',
    paddingLeft: 12,
    '& .CurruncyFormatPrefix': {
      position: 'absolute',
      left: 0,
    },
  },
}));

const CurruncyFormat = ({
  prefix = '',
  thousandsGroupStyle = 'thousand',
  decimalSeparator = '.',
  thousandSeparator = true,
  allowNegative = true,
  value = '',
  className = '',
}) => {
  const classes = useStyles();

  return (
    <span className={`${classes.root} ${className}`}>
      {prefix ? <span className="CurruncyFormatPrefix">{prefix}</span> : ''}
      <NumberFormat
        thousandsGroupStyle={thousandsGroupStyle}
        value={value}
        decimalSeparator={decimalSeparator}
        displayType="text"
        thousandSeparator={thousandSeparator}
        allowNegative={allowNegative}
      />
    </span>
  );
};

export default CurruncyFormat;
